import React, { Component } from 'react';
import { Badge } from 'antd';

// Use this Component :
// put a props with name "startDate" in components call
// props "startDate" must be a "new Date().getTime()"

export default class Timer extends Component {
  state = {
    endDate: new Date().getTime(),
    timerColor: this.props.isAttributed ? "#e9fbf3" : "#F9DFDD"
  }

  componentDidMount() {
    this.timerID = setInterval(() => this.tick(), 1000);
  }

  componentWillUnmount() {
    clearInterval(this.timerID);
  }

  tick() {
    this.setState({ endDate: new Date().getTime() });
  }

  Timer = (start, end) => {
    const { timerColor } = this.state;
    const { isAttributed } = this.props;

    const seconds = (Math.floor((end - start) / 1000) % 60);
    const minutes = (Math.floor((end - start) / (60 * 1000)) % 60);
    const hours = (Math.floor((end - start) / (60 * 60 * 1000)) % 24);

    if (!isAttributed && hours >= 0 && minutes >= 1 && timerColor === "#F9DFDD") this.setState({ timerColor: "#F2ADAA" });
    if (!isAttributed && hours >= 0 && minutes >= 3 && timerColor === "#F2ADAA") this.setState({ timerColor: "#EE8D89" });

    if (isAttributed && hours >= 0 && minutes < 1 && [
      "#F9DFDD",
      "#F2ADAA",
      "#EE8D89"
    ].includes(timerColor)) this.setState({ timerColor: "#e9fbf3" });
    if (isAttributed && hours >= 0 && minutes >= 1 && timerColor === "#e9fbf3") this.setState({ timerColor: "#bef4da" });
    if (isAttributed && hours >= 0 && minutes >= 3 && timerColor === "#bef4da") this.setState({ timerColor: "#98EDC4" });

    let time = '';

    if (hours < 10) time += `0${hours}`;
    else time += hours;

    if (minutes < 10) time += ` : 0${minutes}`;
    else time += ` : ${minutes}`;

    if (seconds < 10) time += ` : 0${seconds}`;
    else time += ` : ${seconds}`;

    return time;
  }

  render() {
    const { endDate, timerColor } = this.state;
    const { type, startDate } = this.props;

    if (type === "badge") {
      return (<Badge count={this.Timer(startDate, endDate)} style={{ backgroundColor: timerColor, color: '#272727', fontWeight: 500, fontFamily: 'Poppins' }} />);
    } else {
      return (<div style={{ fontWeight: 500, fontFamily: 'Poppins' }}>{this.Timer(startDate, endDate)}</div>);
    }
  }
}